import { tokenRefreshJob } from './token.refresh.job';
import { schedule } from './job.scheduler';

const jobs = [{ job: tokenRefreshJob, periodInMilliseconds: 60 * 1000 }];

export default {
  start: () => jobs.map(_ => schedule(_.job, _.periodInMilliseconds))
};
